



























import { Component, Vue, Emit } from "vue-property-decorator";

@Component
export default class ReportCreateDialog extends Vue {
    public name: string = "";

    @Emit() submit() {
        this.$store.commit("showSnackbar", {
            text: this.$t("report.saved") as string,
            color: "success",
        });
        return this.name;
    }
}
